/*
npm install viewerjs
https://fengyuanchen.github.io/viewerjs/
https://github.com/fengyuanchen/viewerjs


*/

import Viewer from 'viewerjs'
const itemList = document.getElementsByClassName('js-viewer')
if (itemList[0]) {
  module()
}

let lastScale = 0 // 拡大率メモリ
function module() {
  // オプション
  // https://github.com/fengyuanchen/viewerjs#options

  for (const item of itemList) {
    let slide = 0

    if (item.dataset.slide === '1') {
      slide = 1
    }

    const options = {
      title: false,
      navbar: false, // 画像一覧
      keyboard: false,
      tooltip: true,
      movable: true,
      zoomable: true,
      rotatable: false,
      scalable: false,
      fullscreen: false,
      toolbar: {
        prev: slide,
        zoomIn: 1,
        zoomOut: 1,
        oneToOne: 0,
        reset: 0,
        play: {
          show: 0,
          size: 'large',
        },
        next: slide,
        rotateLeft: 0,
        rotateRight: 0,
        flipHorizontal: 0,
        flipVertical: 0,
      },
      built: function () {},
      shown: function () {},
      viewed: function () {},
    }

    const viewer = new Viewer(item, options)

    //  ######   #####    #####   ###    ###
    //     ##   ##   ##  ##   ##  ## #  # ##
    //    ##    ##   ##  ##   ##  ##  ##  ##
    //   ##     ##   ##  ##   ##  ##      ##
    //  ######   #####    #####   ##      ##
    // スライド間で拡大率を引き継ぐ
    item.addEventListener('zoom', function (e) {
      // 拡大率の保存
      lastScale = e.detail.ratio
    })
    item.addEventListener('hidden', function (e) {
      // 閉じたら拡大率を破棄
      lastScale = 0
    })
    item.addEventListener('viewed', function (e) {
      if (lastScale >= 0.2) {
        // 拡大率が一定以上あれば復元
        viewer.zoomTo(lastScale)
      }
    })
  }
}
